export async function isNewBuild(currentVersion: string, fetchVersion: typeof fetch = fetch): Promise<boolean> {
  try {
    const response = await fetchVersion(`/version.json?check=${Date.now()}`, { cache: 'no-store' });
    if (!response.ok) return false;
    const payload: unknown = await response.json();
    return typeof payload === 'object' && payload !== null &&
      'version' in payload && typeof payload.version === 'string' &&
      payload.version.length > 0 && payload.version !== currentVersion;
  } catch {
    // Offline or a deployment in progress: keep the current page usable.
    return false;
  }
}
